import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';

import { Strings } from '../../utils/resources/strings';
import { PasswordValidationCCRequest } from '../api/passwordvalidationcc/passwordvalidationccrequest';
import { PasswordValidationCCResponse, PasswordValidationCCResponseDtoImpl } from '../api/passwordvalidationcc/passwordvalidationccresponse';
import { APIProcessorImpl } from './apiProcessor';
import { PasswordValidationCCDto } from '../dto/passwordvalidationcc/passwordvalidationccdto';

export class PasswordValidationCCAPIProcessorImpl extends APIProcessorImpl<PasswordValidationCCRequest, PasswordValidationCCResponse>
{
    private LOGGER: Logger = LogManager.getLogger(PasswordValidationCCAPIProcessorImpl.name);
    private passwordValidationDto: PasswordValidationCCDto;
    // private channelId: string;

     execute(request: PasswordValidationCCRequest): void
    {
        this.passwordValidationDto = request.getPasswordValidationCCRequest();
        // this.channelId = request.getPasswordValidationCCRequest().getChannel();
        super.execute(request);
    }
     
     onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            this.LOGGER.log("onSuccess() invoked : "+responseMapper.getStatusCode());
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                let response = new PasswordValidationCCResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION_CC , "Valid Password");

                let responseMap = responseMapper.getResponseMap();
                let getUserContext = this.getContext().getUserContext();
                let context = this.getContext();

                context.getProperty().setChannelId(this.passwordValidationDto.getChannel());
                
                getUserContext.setAccessToken(responseMap.accessToken);
                getUserContext.setRefreshToken(responseMap.refreshToken);
                getUserContext.setChannelId(this.passwordValidationDto.getChannel());
                getUserContext.setMsisdn(this.passwordValidationDto.getMsisdn());
                getUserContext.setUserName(this.passwordValidationDto.getUsername());
                getUserContext.setDeviceId(responseMap.deviceId);
                getUserContext.setExpiry((responseMap.expiry - context.getProperty().getRefreshTokenDelta()
                                       ) + Date.now());
                getUserContext.setExpiryTimeStamp(this.getContext().getProperty().getSessionTimeout() + 
                                       Date.now());
                getUserContext.setIsLoggedIn(true);

                // context.setConfigurationSettings(JSON.parse(JSON.stringify(responseMap.settings)).others);
                context.setUserContext(getUserContext);
                
                this.LOGGER.log("Access Token : "+getUserContext.getAccessToken());
                this.LOGGER.log("Refresh Token : "+getUserContext.getRefreshToken());
                this.LOGGER.log("Msisdn : "+getUserContext.getMsisdn());
                this.LOGGER.log("DeviceId : "+getUserContext.getDeviceId());
                this.LOGGER.log("Expiry : "+getUserContext.getExpiry());
                this.LOGGER.log("Is Login : "+getUserContext.getIsLoggedIn());

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new PasswordValidationCCResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION_CC, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new PasswordValidationCCResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION_CC, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new PasswordValidationCCResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION_CC, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        this.getAPIFailure(new PasswordValidationCCResponseDtoImpl(APIFeatures.PASSWORD_VALIDATION_CC, responseMapper.getStatusMsg()));       
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/passwordvalidationccapiprocessor.tsx